import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleHalfStroke, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { getThemePreference, setThemePreference, subscribeTheme } from './theme';

// Cycle order: each click moves to the next mode. Light is the default; Dark and System are
// opt-in previews while dark mode is in testing.
const MODES = [
  { value: 'light', label: 'Light', icon: faSun, hint: 'default' },
  { value: 'dark', label: 'Dark', icon: faMoon, hint: 'preview' },
  { value: 'system', label: 'System', icon: faCircleHalfStroke, hint: 'follows your device, preview' },
];

// Header control for the colour theme (REZ-1299). Shows the current mode; clicking switches
// to the next one instantly. The choice is stored per browser.
const ThemeToggle = ({ style }) => {
  const [preference, setPreference] = useState(getThemePreference);

  useEffect(() => subscribeTheme((state) => setPreference(state.preference)), []);

  const index = Math.max(
    0,
    MODES.findIndex((m) => m.value === preference),
  );
  const current = MODES[index];
  const next = MODES[(index + 1) % MODES.length];
  const description = `Theme: ${current.label} (${current.hint}). Click to switch to ${next.label}.`;

  return (
    <button
      type="button"
      className="rr-theme-toggle"
      style={style}
      title={description}
      aria-label={description}
      onClick={() => setThemePreference(next.value)}
    >
      <FontAwesomeIcon icon={current.icon} />
    </button>
  );
};

export default ThemeToggle;
